import { useField, useFormikContext } from 'formik';

import { FormattedNumberInput } from './FormattedNumberInput';
import type { FormattedNumberInputProps } from './FormattedNumberInput';

interface FormikFormattedNumberInputProps
    extends Omit<
        FormattedNumberInputProps,
        'prefix' | 'groupSeparator' | 'decimalSeparator' | 'onValueChange' | 'onChange' | 'onBlur' | 'value'
    > {
    name: string;
}

export const FormikFormattedNumberInput = ({ step = 1, maxLength = 10, ...props }: FormikFormattedNumberInputProps) => {
    const [field, meta, helpers] = useField(props.name);
    const { validateOnChange } = useFormikContext();

    const handleOnValueChange = (value?: string) => {
        helpers.setValue(value ?? '');
        if (!validateOnChange && meta.error) {
            helpers.setError(undefined);
        }
    };

    return (
        <FormattedNumberInput
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error && typeof meta.error === 'string' ? meta.error : props.caption}
            onValueChange={handleOnValueChange}
            step={step}
            maxLength={maxLength}
            groupSeparator=","
            decimalSeparator="."
            {...props}
            name={field.name}
            value={field.value}
            onBlur={field.onBlur}
        />
    );
};
